import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import Button from "react-bootstrap/Button";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { profile } from "../../data/profile";
import Contact from "./Contact";
import { motion } from "framer-motion";
import WhatIDo from "./WhatIDo";
import { ImPointRight } from "react-icons/im";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <motion.h1
                style={{ paddingBottom: 15 }}
                className="heading"
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.45, ease: "easeOut" }}
              >
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </motion.h1>

              <motion.h1
                className="heading-name"
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.45, ease: "easeOut", delay: 0.05 }}
              >
                I'M
                <strong className="main-name"> {profile.name.toUpperCase()}</strong>
              </motion.h1>

              <motion.p
                className="home-hero-headline"
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.45, ease: "easeOut", delay: 0.1 }}
              >
                {profile.title} · {profile.location} · 9+ years
              </motion.p>

              <motion.p
                className="home-hero-intro"
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.45, ease: "easeOut", delay: 0.15 }}
              >
                {profile.intro}
              </motion.p>

              <motion.ul
                className="home-hero-highlights"
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.45, ease: "easeOut", delay: 0.18 }}
              >
                {profile.highlights.map((h) => (
                  <li key={h}>
                    <ImPointRight className="home-hero-bullet" />
                    <span>{h}</span>
                  </li>
                ))}
              </motion.ul>

              <div style={{ padding: "25px 50px 10px", textAlign: "left" }}>
                <Type />
              </div>

              <motion.div
                className="home-hero-cta"
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.45, ease: "easeOut", delay: 0.2 }}
              >
                <Button
                  className="btn-gradient"
                  onClick={() => {
                    const el = document.getElementById("projects");
                    if (el) el.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  View My Work
                </Button>
                <Button
                  variant="outline-light"
                  className="btn-outline-neon"
                  href={profile.resume.url}
                  target="_blank"
                  style={{ marginLeft: "10px" }}
                >
                  {profile.resume.label}
                </Button>
                <Button
                  variant="link"
                  className="btn-link-neon"
                  onClick={() => {
                    const el = document.getElementById("contact");
                    if (el) el.scrollIntoView({ behavior: "smooth" });
                  }}
                  style={{ marginLeft: "10px" }}
                >
                  Contact Me
                </Button>
              </motion.div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid home-hero-illustration"
                style={{ maxHeight: "450px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
      <WhatIDo />

      <Container>
        <Row style={{ paddingTop: "50px", paddingBottom: "80px" }}>
          <Col md={12} className="home-about-social">
            <h1>Find Me On</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href={profile.contact.github}
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href={profile.contact.linkedin}
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>

      <Contact />
    </section>
  );
}

export default Home;
